// Returns { startDate, startTime, endDate, endTime } for the last 24 hours
// ending one hour before the current hour, matching the Dashboard convention.
export const getDefaultDateRange = () => {
  const end = new Date();
  end.setMinutes(0, 0, 0);
  const start = new Date(end.getTime() - 24 * 60 * 60 * 1000);
  const endMinusHour = new Date(end.getTime() - 60 * 60 * 1000);
  return {
    startDate: start.toLocaleDateString("sv"),
    startTime: start.toLocaleTimeString("en-GB"),
    endDate: end.toLocaleDateString("sv"),
    endTime: endMinusHour.toLocaleTimeString("en-GB"),
  };
};
